import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import ContractorFinancialDetailsForm from './ContractorFinancialDetailsForm';
import { euCountries, countries } from './countries';
import { useTranslation } from 'react-i18next';
const ProjectContractorForm = _ref => {
  let {
    handleDeleteDetail,
    handleCreateDetail,
    addFile,
    handleFinancialDetailChange,
    saveFinancialDetailChange,
    handleChange,
    contractor,
    handleSubmit,
    saveFinancialYearChange,
    closeForm,
    removeAttachment,
    setSelectedContractor,
    loading,
    applicationSubmitted
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('companysuniversityresearch_institute_name'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    value: contractor.research_institute_name,
    name: "research_institute_name",
    onChange: handleChange,
    size: "md",
    type: "text",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('contracting_partners_type'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "partners_type",
    onChange: handleChange,
    size: "md",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz',
    value: contractor.partners_type
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "unaffiliated_company"
  }, t('other_unaffiliated_company')), /*#__PURE__*/React.createElement("option", {
    value: "affiliated_company"
  }, t('affiliated_company')), /*#__PURE__*/React.createElement("option", {
    value: "research_institute"
  }, t('research_institute')), /*#__PURE__*/React.createElement("option", {
    value: "university"
  }, t('university')), /*#__PURE__*/React.createElement("option", {
    value: "unknown"
  }, t('contractor_unknown'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('legal_form'), "*"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "legal_form",
    onChange: handleChange,
    size: "md",
    value: contractor.legal_form,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "aktiengesellschaft"
  }, "Aktiengesellschaft (AG)"), /*#__PURE__*/React.createElement("option", {
    value: "aktiengesellschaft_kg"
  }, "Aktiengesellschaft und Co. KG (AG u. Co. KG)"), /*#__PURE__*/React.createElement("option", {
    value: "aktiengesellschaft_ohg"
  }, "Aktiengesellschaft und Co. OHG (AG & Co. OHG)"), /*#__PURE__*/React.createElement("option", {
    value: "kapitalgesellschaft"
  }, "Ausl\xE4ndische Rechtsform die einer Kapitalgesellschaft entspricht"), /*#__PURE__*/React.createElement("option", {
    value: "personengesellschaft"
  }, "Ausl\xE4ndische Rechtsform die einer Personengesellschaft entspricht"), /*#__PURE__*/React.createElement("option", {
    value: "eingetragene_gennosenchaft"
  }, "Eingetragene Genossenschaft (eG)"), /*#__PURE__*/React.createElement("option", {
    value: "eingetragener_verein"
  }, "Eingetragener Verein (e.V.)"), /*#__PURE__*/React.createElement("option", {
    value: "einzelunternehmer"
  }, "Einzelunternehmer"), /*#__PURE__*/React.createElement("option", {
    value: "juristische_person"
  }, "Juristische Person des \xD6ffentlichen Rechts"), /*#__PURE__*/React.createElement("option", {
    value: "europ\xE4ische_gesellschaft"
  }, "Europ\xE4ische Gesellschaft (SE)"), /*#__PURE__*/React.createElement("option", {
    value: "europ\xE4ische_wirtschaftliche"
  }, "Europ\xE4ische Wirtschaftliche Interessenvereinigung (EWIV)"), /*#__PURE__*/React.createElement("option", {
    value: "gesellschaft_haftung"
  }, "Gesellschaft mit beschr\xE4nkter Haftung (GmbH)"), /*#__PURE__*/React.createElement("option", {
    value: "gesellschaft_haftung_kg"
  }, "Gesellschaft mit beschr\xE4nkter Haftung und Co. KG (GmbH & Co. KG)"), /*#__PURE__*/React.createElement("option", {
    value: "gesellschaft_haftung_ohg"
  }, "Gesellschaft mit beschr\xE4nkter Haftung und Co. OHG (GmbH & Co. OHG)"), /*#__PURE__*/React.createElement("option", {
    value: "gbr"
  }, "Gesellschaft des b\xFCrgerlichen Rechts (GbR)"), /*#__PURE__*/React.createElement("option", {
    value: "kommanditgesellschaft"
  }, "Kommanditgesellschaft (KG)"), /*#__PURE__*/React.createElement("option", {
    value: "kommanditgesellschaft_afu_aktien"
  }, "Kommanditgesellschaft auf Aktien (KGaA)"), /*#__PURE__*/React.createElement("option", {
    value: "ohg"
  }, "Offene Handelsgesellschaft (OHG)"), /*#__PURE__*/React.createElement("option", {
    value: "partnerschaft"
  }, "Partnerschaft"), /*#__PURE__*/React.createElement("option", {
    value: "sonstige_ausl\xE4ndische_rechtsform"
  }, "Sonstige ausl\xE4ndische Rechtsform"), /*#__PURE__*/React.createElement("option", {
    value: "sonstige_personengesellschaft"
  }, "Sonstige Personengesellschaft")))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('street'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: "Street",
    onChange: handleChange,
    name: "street",
    value: contractor.street,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('house_number'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: handleChange,
    name: "house_number",
    placeholder: "House Number",
    value: contractor.house_number,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('additional_house_number_details')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "additional_house_number_details",
    onChange: handleChange,
    placeholder: t('additional_house_number_details'),
    value: contractor.additional_house_number_details,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('location'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: "Location",
    onChange: handleChange,
    name: "location",
    value: contractor.location,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('post_code'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: handleChange,
    name: "postcode",
    placeholder: "Postcode",
    value: contractor.postcode,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('additional_address_details')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "additional_address_details",
    onChange: handleChange,
    placeholder: t('additional_address_details'),
    value: contractor.additional_address_details,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('country'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "country",
    onChange: handleChange,
    size: "md",
    value: contractor.country,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), countries.map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c);
  }))), contractor.country === 'Germany' && /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('federal_street'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: contractor.state_of_tax_office,
    name: "state_of_tax_office",
    onChange: handleChange,
    size: "md",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "baden_wuerttemberg"
  }, "Baden-Wuerttemberg"), /*#__PURE__*/React.createElement("option", {
    value: "bayern"
  }, "Bayern"), /*#__PURE__*/React.createElement("option", {
    value: "berlin"
  }, "Berlin"), /*#__PURE__*/React.createElement("option", {
    value: "brandenburg"
  }, "Brandenburg"), /*#__PURE__*/React.createElement("option", {
    value: "bremen"
  }, "Bremen"), /*#__PURE__*/React.createElement("option", {
    value: "hamuburg"
  }, "Hamburg"), /*#__PURE__*/React.createElement("option", {
    value: "hesse"
  }, "Hesse"), /*#__PURE__*/React.createElement("option", {
    value: "mecklenburg_vorpommern"
  }, "Mecklenburg-Vorpommern"), /*#__PURE__*/React.createElement("option", {
    value: "lower_saxony"
  }, "Lower Saxony"), /*#__PURE__*/React.createElement("option", {
    value: "north_rhine_westphalia"
  }, "North Rhine-Westphalia"), /*#__PURE__*/React.createElement("option", {
    value: "rheinland_pfalz"
  }, "Rheinland-Pfalz"), /*#__PURE__*/React.createElement("option", {
    value: "saarland"
  }, "Saarland"), /*#__PURE__*/React.createElement("option", {
    value: "saxony"
  }, "Saxony"), /*#__PURE__*/React.createElement("option", {
    value: "saxony_anhalt"
  }, "Saxony-Anhalt"), /*#__PURE__*/React.createElement("option", {
    value: "schleswig_holstein"
  }, "Schleswig-Holstein"), /*#__PURE__*/React.createElement("option", {
    value: "thuringia"
  }, "Thuringia")))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 2
  }, t('member_state')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    disabled: true,
    type: "radio",
    label: "EU/EEA State",
    value: "true",
    checked: euCountries.includes(contractor.country),
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    disabled: true,
    type: "radio",
    label: "Non EU/EEA State",
    value: "false",
    checked: !euCountries.includes(contractor.country),
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 10
  }, t('does_the_contractor_have_a_german_tax_number'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: contractor.has_tax_number,
    name: "has_tax_number",
    onChange: handleChange,
    size: "md",
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, t('no'))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('description_on_the_commissioned_rd_work_and_associated_objectives'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "rnd_work_objectives",
    onChange: handleChange,
    value: contractor.rnd_work_objectives,
    as: "textarea",
    rows: 16,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz'
  })), /*#__PURE__*/React.createElement(Col, {
    md: {
      offset: 11,
      span: 1
    }
  }, contractor.rnd_work_objectives?.length || 0, " / 500"))), contractor.id && /*#__PURE__*/React.createElement(ContractorFinancialDetailsForm, {
    loading: loading,
    applicationSubmitted: applicationSubmitted && contractor.contractor_type === 'bfsz',
    addFile: addFile,
    contractor: contractor,
    saveFinancialYearChange: saveFinancialYearChange,
    handleFinancialDetailChange: handleFinancialDetailChange,
    saveFinancialDetailChange: saveFinancialDetailChange,
    handleCreateDetail: handleCreateDetail,
    handleDeleteDetail: handleDeleteDetail,
    removeAttachment: removeAttachment,
    setSelectedContractor: setSelectedContractor
  })), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleSubmit(),
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    disabled: applicationSubmitted && contractor.contractor_type === 'bfsz',
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: () => closeForm(),
    loading: loading,
    variant: "light"
  }, t('close form')))));
};
export default ProjectContractorForm;